var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"notification_body"},[(_vm.hasTitulo)?_c('strong',[_vm._v(_vm._s(_vm.titulo))]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }